import { SmartChargingStatus } from '@vae/server/src/interfaces/eNode/eNodeSmartCharging.interface'
import { ENodeVehicle } from '@vae/server/src/interfaces/eNode/eNodeVehicle.interface'
import React from 'react'
import SmartChargingToggle from './SmartChargingToggle'
import SmartChargingVisualiser from './SmartChargingVisualiser'

interface SmartChargingProps {
	setSmartChargingPolicy: ({
		hashedPid,
		vehicleId,
		options,
	}: {
		hashedPid: string
		vehicleId: string
		options: {
			isEnabled: boolean
			deadline: string
		}
	}) => void
	vehicle: ENodeVehicle | null | undefined
	smartChargingStatus: SmartChargingStatus | undefined | null
}
const SmartCharging = ({
	setSmartChargingPolicy,
	vehicle,
	smartChargingStatus,
}: SmartChargingProps) => {
	return (
		<div className='smart-charging flex flex-col overflow-hidden border bg-white dark:bg-brand-secondary-200-dark border-brand-primary-100-light dark:border-brand-primary-100-dark'>
			<SmartChargingVisualiser smartChargingStatus={smartChargingStatus} vehicle={vehicle} />
			<SmartChargingToggle setSmartChargingPolicy={setSmartChargingPolicy} vehicle={vehicle} />
		</div>
	)
}

export default SmartCharging
